import http from 'hub-http/clients/apiClient';
export const fetchCallTypes = () => {
  return http.get('/engagements/v1/activity-types/');
};